
import Vue from 'vue'
import MomentToMomentRatings from '@/apps/activity/components/MomentToMomentRatings.vue'

const MomentToMomentRatingsStory = Vue.extend({
  data: () => ({
    title: 'My Rating Control',
    minValue: 1,
    maxValue: 10,
    maxLabel: 'Awesome',
    minLabel: 'Awful',
    rating: null,
  }),
  components: {
    MomentToMomentRatings,
  },
  watch: {
    rating(v) {
      console.log('rating', v)
    },
  },
  methods: {
    onChange(v) {
      console.log(v)
    },
  },
})

export default MomentToMomentRatingsStory
